import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Content, Flex } from '@leverege/ui-elements';
import { Selection } from '@leverege/ui-redux';
import { Toolbar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import NoDataView from "../views/NoDataView.js";
import TableView from "./TableView.js";
import TablePagination from "./TablePagination.js";
import { useSelect, useRowProps, useCellProps } from "./hooks/index.js";
import TableModelInitializer from "../../attributes/TableModelInitializer.js";
import S from './TableContentView.css';
import { HeaderToolbar } from "../Util.js"; // simple test
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TableContentView(props) {
  const variant = 'dataTable';
  const {
    objectType,
    paginator,
    relationship: {
      path
    },
    model,
    settingsData,
    onSettingsChange,
    overrideModel,
    inCard
  } = props;
  const editable = (overrideModel?.editable != null ? overrideModel.editable : model?.editable) || false;
  const oModel = useMemo(() => {
    return {
      ...model,
      editable
    };
  }, [model, editable]);
  const context = {
    clientProps: {
      ...props,
      columns: oModel.columns,
      path
    },
    editable
  };
  const actionBarMatchContext = {
    use: 'actionBar',
    client: TableView.CLIENT,
    objectType,
    path
  };
  const filterBarMatchContext = {
    use: 'filterBar',
    client: TableView.CLIENT,
    objectType,
    path
  };
  const footerMatchContext = {
    client: TableView.CLIENT,
    objectType,
    path
  };
  const onUpdateTableModel = useCallback(({
    value
  }) => {
    onSettingsChange({
      value,
      data: settingsData
    });
  }, [onSettingsChange, settingsData]);
  const afterHooks = useMemo(() => {
    return [useSelect, useRowProps, useCellProps];
  }, []);
  let noDataMessage = Config.get(TableView.CLIENT, 'noDataMessage', NoDataView);
  if (noDataMessage != null && typeof noDataMessage !== 'string') {
    // assume its a component class/function
    const Clazz = noDataMessage;
    noDataMessage = /*#__PURE__*/_jsx(Clazz, {
      ...props,
      client: TableView.CLIENT
    });
  }
  const headerContent = /*#__PURE__*/_jsxs(Flex, {
    className: inCard ? undefined : S.toolbars,
    variant: "tableToolbar",
    children: [/*#__PURE__*/_jsx(Toolbar, {
      className: S.toolbar,
      variant: "filterBar|actionBar",
      matchContext: filterBarMatchContext,
      context: context
    }), /*#__PURE__*/_jsx(Toolbar, {
      className: S.toolbar,
      variant: "actionBar",
      prefer: "icon",
      matchContext: actionBarMatchContext,
      context: context
    })]
  });
  return /*#__PURE__*/_jsxs(Content, {
    className: S.content,
    children: [/*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(HeaderToolbar, {
        inCard: inCard,
        content: headerContent
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsx(TableView, {
        ...props,
        total: paginator.count,
        model: oModel,
        settings: oModel,
        path: path,
        context: context,
        variant: variant,
        paginate: false,
        pageItems: paginator.pageItems,
        afterHooks: afterHooks,
        onUpdateTableModel: onUpdateTableModel,
        noDataMessage: noDataMessage
      })
    }), /*#__PURE__*/_jsx(Content.Footer, {
      children: /*#__PURE__*/_jsx(TablePagination, {
        context: context,
        matchContext: footerMatchContext,
        paginator: paginator
      })
    })]
  });
}
TableView.CLIENT = 'TableDataViewer';
export default connect((state, props) => {
  const {
    selectionKey = 'selection',
    rolloverKey = 'rollover',
    targetKey = 'target',
    loading,
    paginator,
    objectType,
    settings
  } = props;
  let tM = settings;
  if (!tM || !tM.columns || tM.columns.length === 0) {
    tM = TableModelInitializer.create(objectType, true, props);
  }
  const hasItems = paginator.pageItems.some(i => i != null);
  return {
    model: tM,
    selection: Selection.get(state, selectionKey),
    rollover: Selection.get(state, rolloverKey),
    targeted: Selection.get(state, targetKey),
    loading: loading && !hasItems
  };
})(/*#__PURE__*/React.memo(TableContentView));